import { bookServiceApi } from '@/services/api';

export interface MySection {
  section_id: number;
  section_number: number;
  is_done: boolean;
  title: string;
  summary: string;
  section_type?: 'novel' | 'nonfiction' | string;
  is_free?: boolean;
  previous_section_summary?: string | null;
  trailer?: string | null;
  content?: {
    paragraphs: { index: number; content: string; reactions: any[] | number }[];
  } | null;
  heat_level?: number;
}

export interface MyChapter {
  chapter_id: number;
  chapter_number: number;
  title: string;
  chapter_progress: number; // 0-100
  status?: 'in_progress' | 'completed' | 'reviewed';
  sections: MySection[];
  next_section_id?: number | null;
  next_section_title?: string | null;
}

export interface MySectionsResponse {
  // When data exists
  book_id?: number;
  title?: string;
  analysis_text?: string | null;
  cover_image_url?: string;
  book_progress?: number; // 0-100
  is_premium?: boolean; // Premium access status
  // Always present
  chapters: MyChapter[];
  // When user has not started any book
  message?: string;
}

export const getMySections = async (bookId: number): Promise<MySectionsResponse> => {
  const res = await bookServiceApi.get<MySectionsResponse>(`/books/${bookId}/chapters/my-sections`);
  if (res.success && res.data) {
    return res.data;
  }
  throw new Error(res.error || 'Failed to fetch learning path');
};
